import A11yDialog from 'a11y-dialog';

export function catalogSidebar() {
  const triggers = document.querySelectorAll('[data-sidebar-open="catalog"]');

  const dialogEl = document.getElementById('catalog-sidebar');
  const dialog = new A11yDialog(dialogEl);

  const open = () => {
    dialog.show();
    triggers.forEach((element) => element.classList.add('is-active'));
  };
  const close = () => {
    dialog.hide();
    triggers.forEach((element) => element.classList.remove('is-active'));
  };
  const toggle = () => {
    if (!dialog.shown) {
      open();
    } else {
      close();
    }
  };

  triggers.forEach((element) => {
    element.addEventListener('click', toggle);
  });

  document.querySelectorAll('button.catalog-sidebar__category').forEach((category) => {
    category.addEventListener('click', () => {
      const state = category.getAttribute('aria-expanded') === 'true';
      category.setAttribute('aria-expanded', !state);
    });
  });
}
